import {CARD} from './card';
import {U} from "./global";

export const GTM = {
    usduah: 37,
    pixel_event: function(event, params) {
        if (G.manager_logged || G.b2bmode)
            return;

        let list = {};
        list.id = 428296080869517;
        list.noscript = 1;
        list.ev = event;
        list.cd = params;

        if (!(typeof G.fb === "undefined")) {
            list.ud = {};

            if (!(typeof G.fb.em === "undefined"))
                list.ud.em = G.fb.em;

            if (!(typeof G.fb.ph === "undefined"))
                list.ud.ph = G.fb.ph;
        }

                $("body").append('<img src="https://www.facebook.com/tr?' + $.param(list) + '" height="1" width="1" style="display:none"/>');
    },

    remarketing: function(event) {
        let args = arguments;

        try {
            switch(event) {
                case 'origin_page_view':
                    dataLayer.push({
                        'event': 'fireRemarketingTag',
                        'google_tag_params': args[1]
                    });
                    break;

                case 'product':

                    dataLayer.push({
                        'event': 'fireRemarketingTag',
                        'google_tag_params': {
                            ecomm_pagetype: 'product',
                            ecomm_prodid: args.length > 1 ? args[1] : 0,
                            ecomm_totalvalue: args.length > 2 ? args[2] : 0,
                            ecomm_category: typeof args[3] === "undefined" ? false : args[3],
                            isSaleItem: typeof args[4] === "undefined" ? false : (args[4]?true:false),
                            kr: typeof args[5] === "undefined" ? '' : args[5],
                        }
                    });

                    break;

                case 'category':

                    dataLayer.push({
                        'event': 'fireRemarketingTag',
                        'google_tag_params': {
                            ecomm_pagetype: 'category',
                            ecomm_category: typeof args[1] === "undefined" ? false : args[1],
                        }
                    });

                    break;

                case 'cart':

                    let cart_product = args[1];

                    dataLayer.push({
                            'event': 'fireRemarketingTag',
                            'google_tag_params': {
                                ecomm_pagetype: 'cart',
                                ecomm_prodid: [cart_product.sku],
                                ecomm_totalvalue: cart_product.price,
                                kr: typeof cart_product.kr === "undefined" ? '' : cart_product.kr
                            }
                        }
                    );

                    break;

                case 'purchase':

                    let products = args.length > 1 ? args[1] : [];
                    let ids = [];
                    let summ = 0;

                    $.each(products, function(i, product){
                        ids.push(product.id);
                        summ += parseInt(product.price);
                    });

                    dataLayer.push({
                            'event': 'fireRemarketingTag',
                            'google_tag_params': {
                                ecomm_pagetype: 'purchase',
                                ecomm_prodid: ids,
                                ecomm_totalvalue: summ,
                            }
                        }
                    );

                default:
                    break;
            }
        }
        catch (err) {}

    },

    statTimeout: false,

    fireStatistick: function(category, action, label, value){
        dataLayer.push({
            'event':'sendStatistick',
            'event_category':category,
            'event_action':action,
            'event_label':label,
            'event_value':value,
        });
    },

    old_browser: function() {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName  = navigator.appName;
        var fullVersion  = ''+parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion,10);
        var nameOffset,verOffset,ix;

        // In Opera 15+, the true version is after "OPR/"
        if ((verOffset=nAgt.indexOf("OPR/"))!=-1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset+4);
        }
        // In older Opera, the true version is after "Opera" or after "Version"
        else if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset+6);
            if ((verOffset=nAgt.indexOf("Version"))!=-1)
                fullVersion = nAgt.substring(verOffset+8);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
            browserName = "Explorer";
            fullVersion = nAgt.substring(verOffset+5);
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset+7);
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
            browserName = "Safari";
            fullVersion = nAgt.substring(verOffset+7);
            if ((verOffset=nAgt.indexOf("Version"))!=-1)
                fullVersion = nAgt.substring(verOffset+8);
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
            browserName = "Firefox";
            fullVersion = nAgt.substring(verOffset+8);
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
            (verOffset=nAgt.lastIndexOf('/')) )
        {
            browserName = nAgt.substring(nameOffset,verOffset);
            fullVersion = nAgt.substring(verOffset+1);
            if (browserName.toLowerCase()==browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix=fullVersion.indexOf(";"))!=-1)
            fullVersion=fullVersion.substring(0,ix);
        if ((ix=fullVersion.indexOf(" "))!=-1)
            fullVersion=fullVersion.substring(0,ix);

        majorVersion = parseInt(''+fullVersion,10);
        if (isNaN(majorVersion)) {
            fullVersion  = ''+parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion,10);
        }

        if (browserName=='Chrome' && majorVersion < 53) return true;
        if (browserName=='Explorer' && majorVersion < 10) return true;
        if (browserName=='Safari' && majorVersion < 9) return true;
        if (browserName=='Firefox' && majorVersion < 44) return true;
        if (browserName=='Opera' && majorVersion < 35) return true;

        return false;
    },

    ga_loaded: function() {
        return (typeof ga === 'function');
    },

    isjquery: function(data) {
        // If data is already a jQuery object
        if(data instanceof jQuery) {
            // Do nothing different
            data = data;
            // Otherwise
        } else {
            // Convert to jQuery object
            data = $(data);
        }
        // Return jQuery object
        return data;
    },

    event: function(name) {
        GTM_ADS.event(arguments);
        GTM4N.event(arguments);
        GTM_FACEBOOK_PIXEL.event(arguments);
    },

    getPath: function(element) {
        if (!element) return;
        let path = [];
        while (element && element.tagName.toLowerCase() !== 'html' && element.tagName.toLowerCase() !== 'body') {
            let selector = element.tagName.toLowerCase();
            if (element.id) {
                selector += `#${element.id}`;
            } else if (element.className) {
                let classes = element.className.split(' ').filter(Boolean).join('.');
                selector += `.${classes}`;
            }
            path.unshift(selector);
            element = element.parentElement;
        }
        return path.slice(-3).join(' > ');
    }
};

export const GTM_ADS = {
    event: function(args) {
        GTM4N.clear();
        let _do = () => {};
        let event_name = args[0] ?? '';

        if (G.manager_logged)
            return;

        switch(event_name) {
            case 'add_to_cart':
                _do = () => {
                    let product = args[1];

                    dataLayer.push(
                        {
                            'event': 'ga_addtocart',
                            'ecomm_totalvalue': product.price,
                            'ecomm_currency': 'UAH',
                        }
                    );
                };
                break;

            case 'purchase':
                _do = () => {
                    let order = args[1];
                    let products = args[2];

                    dataLayer.push({
                        'event': 'ga_purchase',
                        'ga_order': {
                            'total_value': order.sum,
                            'transaction_id': order.id,
                            'currency': "UAH",
                            "items": products.map((item) => {
                                return {
                                    "id": item.id.toString(),
                                    "quantity": parseFloat(item.quantity),
                                    "price": parseFloat(item.price)
                                };
                            })
                        }
                    });
                };
                break;

            default:
                break;
        }

        _do();
    }
}

export const GTM_FACEBOOK_PIXEL = {
    event: function(args) {
        let _do = () => {};
        let event_name = args[0] ?? '';

        if (G.manager_logged)
            return;

        switch(event_name) {
            case 'add_to_cart':
                _do = () => {
                    let product = args[1];

                    if (!(typeof product === "undefined") && !(typeof product.price === "undefined")) {
                        if (typeof fbq === "function")
                            fbq('track', 'AddToCart', {
                                value: product.price,
                                currency: 'UAH',
                                content_ids: [product.sku],
                                content_type: 'product'
                            });

                        if (G.facebook_pixel) {
                            let value = product.price/GTM.usduah;
                            let params = {
                                value: product.price,
                                currency: 'UAH',
                                content_ids: [product.sku],
                                content_type: 'product',
                                content_category: product.list
                            };

                            if (!(typeof product.krfb === "undefined")) {
                                params.kr = product.krfb;
                            }

                            if (!isNaN(value)) {
                                GTM.pixel_event('AddToCart', params);
                            }
                        }
                    }

                };
                break;

            case 'purchase':
                _do = () => {
                    let order = args[1];
                    let products = args[2];
                    let skus = [];
                    $.each(products, function(i, index){
                        skus.push(index.id);
                    });

                    if (typeof fbq === "function")
                        fbq('track', 'Purchase', {
                            value: order.sum,
                            currency: 'UAH',
                            content_ids: skus,
                            content_type: 'product'
                        });

                    if (G.facebook_pixel) {
                        let value = order.sum/GTM.usduah;

                        if (!isNaN(value)) {
                            GTM.pixel_event('Purchase', {
                                value: order.sum,
                                currency: 'UAH',
                                content_ids: skus,
                                content_type: 'product'
                            });
                        }
                    }


                };
                break;

            default:
                break;
        }

        _do();
    }
}

export const GTM4N = {
    clear: function() {
        dataLayer.push({ ecommerce: null });
    },

    event: function(args) {
        this.clear();
        let _do = () => {};
        let event_name = args[0] ?? '';

        switch(event_name) {
            case 'generate_lead':
                _do = () => {
                    if (args.length > 2) {
                        let value = args[1] ?? 0;
                        let ep_order_id = args[2] ?? 0;
                        let ep_order_type = args[3] ?? 'order';
                        let products = args[4] ?? [];

                        dataLayer.push({
                            'event': 'generate_lead',
                            'ecommerce': {
                                'currency': "UAH",
                                'value': value,
                                'ep_order_id': ep_order_id,
                                'ep_order_type': ep_order_type,
                                items: products.map(item => {
                                    return {
                                        "item_id": item.id,
                                        "item_name": item.name,
                                        "currency": "UAH",
                                        "price": item.price,
                                        "quantity": item.quantity,
                                        "item_brand": item.brand,
                                        "item_category": item.category,
                                        "type_value": 'normal'
                                    };
                                })
                            }
                        });
                    }
                };
                break;

            case 'add_to_cart':
                _do = () => {
                    if (args.length > 2) {
                        let product = args[1];

                        if (typeof product === "object") {
                            dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                    'currency': 'UAH',
                                    'value': product.price,
                                    'items': [{
                                        'item_name': product.name,
                                        'item_id': product.sku,
                                        'price': product.price,
                                        'item_brand': product.brand,
                                        'item_category': product.category,
                                        'item_variant': product.variant ?? '',
                                        'item_list_id': product.list ?? (args[2] ?? ''),
                                        'item_list_name': product.listname ?? (args[3] ?? ''),
                                        'quantity': 1
                                    }]
                                }
                            });
                        }
                    }
                };
                break;

            case 'select_product':
                _do = () => {
                    dataLayer.push({
                        'event': 'select_product',
                        'assembly': {
                            'event_category': args[1] ?? '',
                            'event_action': args[2] ?? '',
                            'event_label': args[3] ?? 'null',
                        }
                    });
                };
                break;

            case 'remove_from_cart':
                _do = () => {
                    if (args.length > 2) {
                        let product = args[1];

                        if (typeof product === "object") {
                            dataLayer.push({
                                'event': 'remove_from_cart',
                                'ecommerce': {
                                    'currency': 'UAH',
                                    'value': product.price,
                                    'items': [{
                                        'item_name': product.name,
                                        'item_id': product.sku,
                                        'price': product.price,
                                        'item_brand': product.brand,
                                        'item_category': product.category,
                                        'item_variant': product.variant ?? '',
                                        'quantity': 1
                                    }]
                                }
                            });
                        }
                    }
                };
                break;

            case 'checkout_step':
                _do = () => {
                    if (args.length > 1) {

                        let step_number = parseInt(args[1]);
                        let items = [];
                        let value = CARD.paymentTotal();

                        if (CARD.current_data.length)
                            $.each(CARD.current_data, function(i, item){
                                if (item.id && item.id > 0) {
                                    items.push({
                                        'item_name': item.name,
                                        'item_id': item.id,
                                        'price': item.price,
                                        'item_brand': item.brand,
                                        'item_category': item.category,
                                        'item_variant': item.variant ?? '',
                                        'quantity': item.quantity
                                    });
                                }
                            });

                        if (step_number==1 && items.length > 0) {
                            dataLayer.push({
                                'event': 'begin_checkout',
                                'ecommerce': {
                                    'items': items,
                                    'value': value,
                                    'coupon': CARD.active_promocode(),
                                    'currency': 'UAH',
                                }
                            });
                        } else if (step_number==3) {
                            // delivery
                            dataLayer.push({
                                'event': 'add_shipping_info',
                                'ecommerce': {
                                    'coupon': CARD.active_promocode(),
                                    'shipping_tier': $.trim(args[3]),
                                    'value': value,
                                    'currency': 'UAH',
                                    'items': items
                                }
                            });
                        } else if (step_number==4) {
                            // payment
                            dataLayer.push({
                                'event': 'add_payment_info',
                                'ecommerce': {
                                    'coupon': CARD.active_promocode(),
                                    'payment_type': $.trim(args[2]),
                                    'value': value,
                                    'currency': 'UAH',
                                    'items': items
                                }
                            });
                        }
                    }
                }
                break;

            case 'purchase':
                _do = () => {
                    let order = args[1];
                    let products = args[2];
                    let _products = [];

                    if (G.channel==7) {
                        if (products.length > 0) {
                            $.each(products, function(i, item) {
                                _products.push({
                                    'item_name': item.name,
                                    'item_id': item.id,
                                    'price': item.price,
                                    'item_brand': item.brand,
                                    'item_category': item.category,
                                    'item_variant': item.variant ?? '',
                                    'quantity': item.quantity
                                });
                            });
                        }

                        if (_products.length > 0) {
                            dataLayer.push({
                                'event': 'purchase',
                                'ecommerce': {
                                    'currency': 'UAH',
                                    'transaction_id': order.id,
                                    'value': order.sum,
                                    'coupon': CARD.active_promocode(),
                                    'items': _products,
                                }
                            });
                        }
                    }
                };
                break;

            case 'view_cart':
                _do = () => {
                    let items = [];

                    if (CARD.current_data.length)
                        $.each(CARD.current_data, function(i, item){
                            if (item.id && item.id > 0) {
                                items.push({
                                    'item_name': item.name,
                                    'item_id': item.id,
                                    'price': item.price,
                                    'item_brand': item.brand,
                                    'item_category': item.category,
                                    'item_variant': item.variant ?? '',
                                    'quantity': item.quantity
                                });
                            }
                        });

                    dataLayer.push({
                        'event': 'view_cart',
                        'ecommerce': {
                            'value': CARD.paymentTotal(),
                            'currency': 'UAH',
                            'items': items
                        }
                    });
                };
                break;

            case 'product_click':
                _do = () => {
                    if (args.length > 4) {
                        let product = args[1];
                        let position = args[2];
                        let link = args[4];

                        position = parseInt(position);

                        dataLayer.push({
                            'event': 'select_item',
                            'ecommerce': {
                                'items': [{
                                    'item_name': product.data('name'),
                                    'item_id': product.data('sku'),
                                    'price': product.data('price'),
                                    'item_brand': product.data('brand'),
                                    'item_category': product.data('category'),
                                    'item_variant': typeof product.data('variant') === "undefined" ? '' : product.data('variant'),
                                    'item_list_id': product.data('list') ?? '',
                                    'item_list_name': product.data('listname') ?? '',
                                    'index': position,
                                    'quantity': 1
                                }]
                            },
                            'eventCallback': function () {
                            }
                        });
                    }
                }
                break;

            case 'product_details':
                _do = () => {
                    if (args.length > 1) {
                        let product = args[1];
                        if (!(typeof product === "undefined") && !(typeof product.price === "undefined")) {
                            if (typeof fbq === "function")
                                fbq('track', 'ViewContent', {
                                    value: product.price,
                                    currency: 'UAH',
                                    content_ids: [product.sku],
                                    content_type: 'product'
                                });

                            if (G.facebook_pixel) {
                                let value = product.price / GTM.usduah;
                                let params = {
                                    value: product.price,
                                    currency: 'UAH',
                                    content_ids: [product.sku],
                                    content_type: 'product',
                                    content_category: product.list
                                };

                                if (!(typeof product.krfb === "undefined"))
                                    params.kr = product.krfb;

                                if (!isNaN(value))
                                    GTM.pixel_event('ViewContent', params);
                            }
                        }

                        dataLayer.push({
                            'event': 'view_item',
                            'ecommerce': {
                                'value': product.price,
                                'currency': 'UAH',
                                'items': [{
                                    'item_name': product.name,                      // Name or ID is required.
                                    'item_id': product.sku,
                                    'price': product.price,
                                    'item_brand': product.brand,
                                    'item_category': product.category,
                                    'item_variant': product.variant,
                                    'item_list_id': 'product',
                                    'item_list_name': '',
                                    'quantiry': 1
                                }]
                            }
                        });
                    }
                }

                break;

            case 'subscribe_popup':
            case 'subscribe_tab':
            case 'subscribe_open':
            case 'subscribe_send':
            case 'subscribe_catalog':
                dataLayer.push({
                    'event': 'popup',
                    'popup_name': args[0],
                    'popup_value': args[1],
                });
                break;

            case 'menu':
                dataLayer.push({
                    'event': 'menu',
                    'menu_id': args[1],
                    'text': args[2],
                    'parent': args[3],
                });
                break;

            case 'login':
                dataLayer.push({
                    'event': 'login',
                    'method': args[1],
                    'user_id': args[2]
                });
                break;

            case 'user_id':
                dataLayer.push({
                    'user_id': args[1]
                });
                break;

            case 'signup':
                dataLayer.push({
                    'event': 'signup',
                    'method': args[1],
                    'user_id': args[2]
                });
                break;

            case 'switch_language':
                dataLayer.push({
                    'event': 'switch_language',
                    'direction': args[1],
                    'button': args[2]
                });
                break;

            case 'add_to_wishlist':
                _do = () => {
                    let product = args[1];
                    let position = args[2];
                    let list = args[3];
                    let link = args[4];

                    position = parseInt(position);

                    dataLayer.push({
                        'event': 'add_to_wishlist',
                        'ecommerce': {
                            'items': [{
                                'item_name': product.data('name'),
                                'item_id': product.data('sku'),
                                'price': product.data('price'),
                                'item_brand': product.data('brand'),
                                'item_category': product.data('category'),
                                'item_variant': typeof product.data('variant') === "undefined" ? '' : product.data('variant'),
                                'item_list_id': product.data('list') ?? (args[2] ?? ''),
                                'item_list_name': product.data('listname') ?? (args[3] ?? ''),
                                'index': position,
                                'quantity': 1
                            }],
                            'value': product.data('price'),
                            'currency': 'UAH',
                        },
                        'eventCallback': function () {
                            if (!(link == ''))
                                document.location = link;
                        }
                    });
                }
                break;

            case 'push_product_details':
                _do = () => {
                    let product = args[1];
                    dataLayer.push({
                        'event': 'view_item',
                        'ecommerce': {
                            'items': [{
                                'item_name': product.name,                      // Name or ID is required.
                                'item_id': product.sku,
                                'price': product.price,
                                'item_brand': product.brand,
                                'item_category': product.category,
                                'item_variant': product.variant,
                                'item_list_id': product.list,
                                'item_list_name': product.listname,
                                'quantiry': 1
                            }]
                        }
                    });
                }

                break;

            case 'show_impressions':
                _do = () => {
                    let obj = args.length > 1 ? args[1] : [];
                    obj = GTM.isjquery(obj);

                    if (!obj)
                        return;

                    let  data = obj.data();

                    dataLayer.push({
                        'event': 'view_item_list',
                        'ecommerce': {
                            'item_list_name': data.list,
                            'items': [{
                                'item_name': data.name,
                                'item_id': data.sku,
                                'price': data.price,
                                'item_brand': data.brand,
                                'item_category': data.category,
                                'item_variant': data.variant,
                                'index': data.position,
                                'item_list_id': data.list,
                                'item_list_name': data.listname,
                                'quantity': 1
                            }]
                        }
                    });
                }

                break;

            case 'impressions_home':

                _do = () => {
                    let impressions = [];
                    let was = [];
                    let cc = 1;

                    jQuery.each(jQuery('.for-impressionsh'), function (index, elem) {
                        elem = jQuery(elem);
                        let data = elem.data();

                        if (jQuery.inArray(data.sku, was) < 0) {

                            impressions.push({
                                'item_name': data.name,
                                'item_id': data.sku,
                                'price': data.price,
                                'item_brand': data.brand,
                                'item_category': data.category,
                                'item_variant': data.variant,
                                'item_list_id': data.list,
                                'item_list_name': data.listname,
                                'index': cc,
                                'quantity': 1
                            });
                            was.push(data.sku);
                            cc++;
                        }

                    });

                    if (impressions.length)
                        dataLayer.push({
                            'event': 'view_item_list',
                            'ecommerce': {
                                'items': impressions
                            }
                        });
                }

                break;

            case 'view_promotion':

                _do = () => {
                    let data = args.length > 1 ? args[1] : [];

                    dataLayer.push({
                        'event': 'view_promotion',
                        'ecommerce': {
                            'promotion_name': data.name,
                            'promotion_id': data.id
                        }
                    });
                }
                break;

            case 'select_promotion':

                _do = () => {
                    let data = args.length > 1 ? args[1] : [];

                    dataLayer.push({
                        'event': 'select_promotion',
                        'ecommerce': {
                            'promotion_name': data.name,
                            'promotion_id': data.id
                        }
                    });
                }
                break;

            default:
                break;
        }

        _do();
    }
}

export function init_GTM_events() {
    $( document ).ready(function() {

        jQuery("body").on('click', ".main-slider .slide >a", function(e) {
            GTM.fireStatistick('statistick', 'click', 'Слайдер на головній', $(this).attr('href'));
        });

        jQuery("body").on('click', ".buy-in-credit-trigger, .js-buy-in-credit-trigger", function(e) {
            const btn = $(this);
            GTM.fireStatistick('statistick', 'click', 'Відкрити кредитний калькулятор', btn.data('sku'));
        });

        jQuery("body").on('click', ".product__pma", function(e) {
            GTM.fireStatistick('statistick', 'click', 'Інформація про кредит (картка товару)', $(this).attr('title'));
        });

        jQuery("body").on('click', ".loop__pma", function(e) {
            GTM.fireStatistick('statistick', 'click', 'Інформація про кредит (блок товару)', $(this).attr('title'));
        });

        jQuery("body").on('click', ".product .js-go-tabproduct, .body-goods .js-go-tabproduct", function(e) {
            let el = $(this);
            GTM.fireStatistick('statistick', 'click', 'Вкладка товару', el.data('tab'));
        });

        jQuery("body").on('click', ".homepage .h__catalogitem", function(e) {
            GTM.fireStatistick('statistick', 'click', 'Клік на розділ з головної сторінки', $.trim($(this).text()));
        });

        jQuery("body").on('click', ".js-hb__promo-banner", function(e) {
            GTM.fireStatistick('statistick', 'click', 'Клік по банеру', $.trim($(this).attr('href')));
        });

        jQuery("body").on('click', ".homepage .hb__looptitle, .homepage .hb__loopimage", function(e) {
            let el = $(this);
            let title = el.parents('.hb').find('.hb__titletext').text();
            GTM.fireStatistick('statistick', 'click', 'Клік по товарному блоку', title);
        });

        jQuery("body").on('click', ".js-product__infoblock", function(e) {
            let el = $(this);
            GTM.fireStatistick('statistick', 'click', 'Клік по інфоблоку в картці товару', el.data('name'));
        });

        jQuery("body").on("change", ".product__servicetitle-radio [type=checkbox]", function (e) {
            let input = $(this);

            if (input.prop('checked')) {
                let title = input.parent().find('span').text();
                GTM.fireStatistick('statistick', 'click', 'Клік послуга в картці товару', title);
            }
        });

        jQuery("body").on("click", ".js-gtm__hdata", function (e) {
            $.post(
                '/u/hdata',
                {
                    to: 'hdata'
                },
                function(result) {
                    if (Object.entries(result).length > 0) {
                        Object.entries(result).map(item => {
                            localStorage.setItem(item[0], item[1]);
                        });
                    }
                },
                'json'
            );
        });

        function sendToGoogleAnalytics({name, value, id}) {
            console.log({name, value, id});
            GTM.fireStatistick('Web Vitals', name, id, value);
        }

        // Відстеження CLS
        const clsObserver = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (!entry.hadRecentInput && entry.value > 0.1) {
                    // console.log('CLS', entry);
                    sendToGoogleAnalytics({ name: 'CLS', value: entry.value, id: GTM.getPath(entry.sources[0].node) });
                }
            }
        });

        clsObserver.observe({ type: 'layout-shift', buffered: true });

        // Відстеження INP
        const inpObserver = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (entry.entryType === 'event' && (entry.name === 'first-input' || entry.name === 'click')) {
                    // console.log('INP', entry.processingEn    d - entry.startTime, entry);
                    if ((entry.processingEnd - entry.startTime) > 100) {
                        // console.log('INP', entry.processingEnd - entry.startTime, entry);
                        sendToGoogleAnalytics({ name: 'INP', value: entry.processingEnd - entry.startTime, id: GTM.getPath(entry.target) });
                    }
                }
            }
        });

        inpObserver.observe({ type: 'event', buffered: true });
    });
}